const TRAILING_VENDOR_PRODUCT_ID_RE = /\s*\([0-9a-f]{4}:[0-9a-f]{4}\)$/i;

export function displayDeviceLabel(label: string): string {
  return label.replace(TRAILING_VENDOR_PRODUCT_ID_RE, '');
}
